export const SignatureRoundStatus = {
    Unknown: -1,
    Delivered: 0,
    Signing: 1,
    AllSigned: 2,
    Completed: 3,
    Cancelled: 4,
}

export const ContractTemplateAction = {
    Edit: 0,
    Choose: 1,
    Preview: 2
    // Manage: 2,
}

export const RolesOfContractParty = {
    Signer: 1,
    Viewer: 2,
}